import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/switchMap';
import {changeLanguage, changeLanguageError, languageReady} from './actions';

export function onChangeLanguage(action$, store, dependencies) {
  return action$.ofType(changeLanguage.TYPE)
    .switchMap(action =>
      Observable.fromPromise(dependencies.$translate.use(action.payload.key))
        .mapTo(languageReady(action.payload))
        .catch(err => Observable.of(changeLanguageError({key: action.payload.key, err})))
    )
    .catch((err, src$) => {
      console.error('onChangeLanguage encountered an unexpected error', err);

      return Observable.timer(100).mergeMap(() => src$);
    })
}



// WEBPACK FOOTER //
// ./src/js/_libs/angular-translate-redux/src/epics.js